/**
 * Sort an array of objects by the text in a given prop
 * @param {array} array Objects to be sorted
 * @param {string} prop Property to sort by alphabetically
 * @returns {array} Sorted array of objects
 */
export default function sortByPropText(
  array,
  prop,
  direction = null,
  subprop = ""
) {
  let arrayResult = array.sort((a, b) => {
    let propA = ""
    let propB = ""
    if (a && a[prop] && subprop && a[prop][subprop]) {
      if (
        typeof a[prop][subprop] === "string" ||
        a[prop][subprop] instanceof String
      ) {
        propA = a[prop][subprop].toLowerCase()
      } else {
        propA = a[prop][subprop]
      }
    } else if (a && a[prop]) {
      if (typeof a[prop] === "string" || a[prop] instanceof String) {
        propA = a[prop].toLowerCase()
      } else {
        propA = a[prop]
      }
    }

    if (b && b[prop] && subprop && b[prop][subprop]) {
      if (
        typeof b[prop][subprop] === "string" ||
        b[prop][subprop] instanceof String
      ) {
        propB = b[prop][subprop].toLowerCase()
      } else {
        propB = b[prop][subprop]
      }
    } else if (b && b[prop]) {
      if (typeof b[prop] === "string" || b[prop] instanceof String) {
        propB = b[prop].toLowerCase()
      } else {
        propB = b[prop]
      }
    }

    if (direction ? propA > propB : propA < propB) {
      return -1
    }
    if (direction ? propA < propB : propA > propB) {
      return 1
    }
    return 0
  })

  return arrayResult
}

export const sortStudents = (ids, students, sortBy) => {
  let array = []
  Object.keys(ids).forEach(s_id => {
    array.push(students[s_id])
  })
  array = sortByPropText(array, sortBy, false)
  let obj = {}
  array.forEach(item => {
    obj[item.id] = true
  })
  return obj
}
